import FighterInterface, { SerializedFighterType } from "./FighterInterface"
import FighterStatus from "./FighterStatus"
import ValueInterface from "./Value/ValueInterface"

export default class Fighter implements FighterInterface {
  constructor(
    public readonly id: string,
    public readonly type: "me" | "enemy",
    public readonly value: ValueInterface,
    public readonly position: string,
    public readonly status: FighterStatus,
  ) {}

  public clone(): Fighter {
    return new Fighter(
      this.id,
      this.type,
      this.value,
      this.position,
      this.status,
    )
  }

  public setStatus(status: FighterStatus): Fighter {
    return new Fighter(this.id, this.type, this.value, this.position, status)
  }

  public toString(): string {
    return this.value.toString()
  }

  public toJSON(): SerializedFighterType {
    return {
      id: this.id,
      type: this.type,
      value: this.value.toJSON(),
      position: this.position,
      status: this.status,
    }
  }
}
